<template>
    <v-footer
      dark
      color="primary"
      class="footer-section"
    >
      <v-container>
        <v-row class="py-12">
          <!-- Logo and Description -->
          <v-col cols="12" md="4" class="mb-8 mb-md-0">
            <div class="footer-logo mb-6">
              <v-icon size="36" color="gold" class="mb-2">mdi-crown</v-icon>
              <div class="logo-text">ClubLink</div>
              <div class="logo-subtitle">SOFTWARE</div>
            </div>
            <p class="footer-description">
              Elevating private club management with precision, elegance, and innovation since 2025.
            </p>
          </v-col>
  
          <!-- Quick Links -->
          <v-col cols="12" sm="6" md="2" class="mb-8 mb-md-0">
            <h3 class="footer-heading mb-4">Company</h3>
            <div class="footer-links">
              <router-link to="/why" class="footer-link">Why ClubLink</router-link>
              <router-link to="/about" class="footer-link">About Us</router-link>
              <router-link to="/services" class="footer-link">Services</router-link>
              <router-link to="/demo" class="footer-link">Request Demo</router-link>
            </div>
          </v-col>
  
          <v-col cols="12" sm="6" md="2" class="mb-8 mb-md-0">
            <h3 class="footer-heading mb-4">Support</h3>
            <div class="footer-links">
              <router-link to="/documentation" class="footer-link">Documentation</router-link>
              <router-link to="/help" class="footer-link">Help Center</router-link>
              <router-link to="/contact" class="footer-link">Contact Us</router-link>
              <router-link to="/login" class="footer-link">Client Portal</router-link>
            </div>
          </v-col>
  
          <v-col cols="12" sm="6" md="2" class="mb-8 mb-md-0">
            <h3 class="footer-heading mb-4">Legal</h3>
            <div class="footer-links">
              <router-link to="/privacy" class="footer-link">Privacy Policy</router-link>
              <router-link to="/terms" class="footer-link">Terms of Service</router-link>
              <router-link to="/cookies" class="footer-link">Cookie Policy</router-link>
              <router-link to="/security" class="footer-link">Security</router-link>
            </div>
          </v-col>
  
          <!-- Contact Info -->
          <v-col cols="12" sm="6" md="2">
            <h3 class="footer-heading mb-4">Contact</h3>
            <div class="footer-contact">
              <div class="contact-item mb-3">
                <v-icon small color="gold" class="mr-2">mdi-email</v-icon>
                <span>ben@clublink.com</span>
              </div>
              <div class="contact-item mb-3">
                <v-icon small color="gold" class="mr-2">mdi-phone</v-icon>
                <span>339-241-8725</span>
              </div>
              <div class="contact-item">
                <v-icon small color="gold" class="mr-2">mdi-map-marker</v-icon>
                <span>Boston, MA</span>
              </div>
            </div>
          </v-col>
        </v-row>
  
        <v-divider dark class="my-8" style="border-color: rgba(212, 175, 55, 0.2);"></v-divider>
  
        <!-- Bottom Bar -->
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="copyright mb-0">
              © {{ currentYear }} ClubLink Software. All rights reserved.
              <span class="ml-4 gold--text">Crafted with Excellence</span>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </template>
  
  <script>
  export default {
    name: 'AppFooter',
    computed: {
      currentYear() {
        return new Date().getFullYear();
      }
    }
  };
  </script>
  
  <style scoped>
  .footer-section {
    background: linear-gradient(135deg, #1a2e26 0%, #2d4a3e 100%);
    position: relative;
  }
  
  .footer-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, 
      transparent 0%, 
      rgba(212, 175, 55, 0.3) 50%, 
      transparent 100%
    );
  }
  
  .footer-logo {
    text-align: left;
  }
  
  .footer-logo .logo-text {
    font-family: 'Playfair Display', serif;
    font-size: 24px;
    font-weight: 700;
    color: #d4af37;
    letter-spacing: 2px;
  }
  
  .footer-logo .logo-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 3px;
    color: #c9a961;
  }
  
  .footer-description {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .footer-heading {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #d4af37;
  }
  
  .footer-links {
    display: flex;
    flex-direction: column;
  }
  
  .footer-link {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    margin-bottom: 12px;
    transition: all 0.3s ease;
    display: inline-block;
  }
  
  .footer-link:hover {
    color: #d4af37;
    transform: translateX(4px);
  }
  
  .footer-contact {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-item {
    display: flex;
    align-items: center;
  }
  
  .copyright {
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: 0.5px;
  }
  </style>